import * as Sentry from '@sentry/react';
import React, { useEffect, useState } from "react";
import { Close } from '@mui/icons-material';
import { Modal, Typography } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

import COLOR from 'utils/constants/color';
import styled from 'styled-components';
import { PROFILE_AVATARS_LOTTIE } from "utils/assets/images/lootie";
import { useCurrentUser, useProfilePicturePicker, useUserProfileConfig } from 'store/users/selectors';
import { useSocket } from "store/chat/selectors";
import { AvatarCard } from "./UI/Profile/Avatar";

//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------










import {
    TransparentLogoWhite
} from 'utils/assets/images';






const UserModal = styled.div`
    transform: translate(-50%, -50%);
    max-width: 950px;
    padding: 20px;
    outline: none; 
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    @media screen and (max-width: 768px){
        max-width: 95vw;
    }
`;
const UserPopUpArea = styled.div`
    background-color: rgb(82,84,82);
    border-radius: 10px;
    padding: 28px;
    position:relative;
    display: flex;
    flex-direction: column;
    @media screen and (max-width: 768px){
        padding: 15px;
    }
`;
const CloseBtn = styled.div`
    border: none;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    position: absolute;
    top: 0px;
    right: 0px;
    color: white;
    z-index: 1;
`;
const UserArea = styled.div`
    display:flex;
    flex-direction:column;
    overflow:auto;
    overflow-x:auto;
    width: 100%;
    display:flex;
    flex-wrap: wrap;
    flex-direction:row;
    align-items: center;
    justify-content: center;
`;
const UserWrapper = styled.div`
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
`;
const Wrapper = styled.div`
    cursor: pointer;
    border: ${p => p.active ? ` 2px solid green` : 'none'};
    padding: 4px;
    flex-direction: row;
    padding: 2px;
    border-radius: 50%;
    margin:${p => p.active ? ` 18px` : '20px'};
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: row;
    position:relative;
    @media screen and (max-width: 768px){
        margin:${p => p.active ? ` 4px` : '6px'};
    }
`;
const Logo = styled.img`
    height: auto;
    width: 100px;
`;
const LogoBottomRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    width:100%;
`;
const LoaderWrapper = styled.div`
    position:absolute;
    z-index:100;
    top:50%;
    left:40%;
`;
const ImageRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
`;
const StyledTypography = muiStyled(Typography)(({ theme }) => ({
    fontWeight: 400,
    color: 'rgb(255, 255, 255)',
    fontSize: 20,
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 17
}));
const ModalContent = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    max-width: 700px; // Set max-width here
    background-color: white; // Assuming you want a white background
    padding: 20px; // Add some padding
    box-shadow: 24; // Material-UI's recommended shadow for modals
    outline: 'none'; // Remove outline to avoid focusing style
`;

export const ProfileAvatarPicker = ({ onChangeAvatar = () => null }) => {
    const { profile_picture_picker, hideProfilePhotoViewer } = useProfilePicturePicker()
    const [avatarSelected, setAvatarSelected] = useState(null)
    const { profile_config, updateserProfileConfig } = useUserProfileConfig()
    const [loader, setLoader] = useState(false)
    const { socketConnection } = useSocket()
    const currentUser = useCurrentUser()
    useEffect(() => {
        if (profile_config && profile_config.config) {
            setAvatarSelected(profile_config.config.profile_pic)
        }

    }, [profile_config])
    const updateAvatar = async (avatar) => {
        setLoader(true)
        setAvatarSelected(avatar)
        const response = await updateserProfileConfig({ profile_pic: avatar })
        const { chat_config } = response || {};
        if (socketConnection && chat_config) {
            try {
                socketConnection.send(JSON.stringify({ type: "config_update", code: 'config_update', config: chat_config, id: currentUser.id }))
                onChangeAvatar(avatar);
            } catch (error) {
                console.log(error, "socket send update error")
                Sentry.captureException(`242 Error sending socket message: ${error}`);
            }
        }
        setTimeout(hideProfilePhotoViewer, 1000)
        setLoader(false)
    }



    const addShadowLottie = [
        'drop-shadow(10px 10px 5px #5cc6e0)', 
        'drop-shadow(10px 10px 5px #FF0000)',
        'drop-shadow(10px 10px 5px #9345a8)',
        'drop-shadow(10px 10px 5px #436e2a)',
        'drop-shadow(10px 10px 5px #39b002)',
        'drop-shadow(10px 10px 5px #f79934)',
        'drop-shadow(10px 10px 5px #f2498d)',
        'drop-shadow(10px 10px 5px #43345c)',
        'drop-shadow(10px 10px 5px #ed2926)',
        'drop-shadow(10px 10px 5px #3d9acc)',
        'drop-shadow(10px 10px 5px #19827f)',
        'drop-shadow(10px 10px 5px #f2eb1d)',
        'drop-shadow(10px 10px 5px #a7a9ab)',
        'drop-shadow(10px 10px 5px #ff38bb)',
        'drop-shadow(10px 10px 5px #fe7ec8)',
        'drop-shadow(10px 10px 5px #c73cd1)',
        'drop-shadow(10px 10px 5px #1d8cdd)',
        'drop-shadow(10px 10px 5px #4f7d5d)',
        'drop-shadow(10px 10px 5px #f2c911)',
        'drop-shadow(10px 10px 5px #634b96)',
        'drop-shadow(10px 10px 5px #eea5a9)',
        'drop-shadow(10px 10px 5px #841c97)',
        'drop-shadow(10px 10px 5px #e19f5f)',
        'drop-shadow(10px 10px 5px #1d3d65)',
        'drop-shadow(10px 10px 5px #ca4a9b)',
        'drop-shadow(10px 10px 5px #b39bcd)',
        'drop-shadow(10px 10px 5px #702d59)',
        'drop-shadow(10px 10px 5px #13205e)',
        'drop-shadow(10px 10px 5px #a00c30)',
        'drop-shadow(10px 10px 5px #4abdb2)',
        'drop-shadow(10px 10px 5px #39692b)',
        'drop-shadow(10px 10px 5px #000000)',
        'drop-shadow(10px 10px 5px #91378c)',
        'drop-shadow(10px 10px 5px #066204)',
        'drop-shadow(10px 10px 5px #240227)',
        'drop-shadow(10px 10px 5px #38dfdf)',
        'drop-shadow(10px 10px 5px #9e216f)',
        'drop-shadow(10px 10px 5px #672055)',
        'drop-shadow(10px 10px 5px #284147)',
        'drop-shadow(10px 10px 5px #261a24)'
      ];
      

    
    return (<>
        <Modal
            open={profile_picture_picker}
            onClose={hideProfilePhotoViewer}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: "transparent" }}
            className="avtarModl">
            <UserModal className="avtarUsrModl">
                <UserPopUpArea className="avtarUsrArea">
                    <StyledTypography variant="h4">Please select your avatar:</StyledTypography>
                    <CloseBtn onClick={hideProfilePhotoViewer}>
                        <Close style={{ color: COLOR.white, fontWeight: "bolder", fontSize: 25 }} />
                    </CloseBtn>
                    <UserArea className="avtarUsrImg">
                        <div className='avatarConatiner'>
                            {PROFILE_AVATARS_LOTTIE.map((avatar, index) => (
                                <AvatarCard
                                    key={avatar.key}
                                    avatar={avatar}
                                    isSelected={avatar.key === avatarSelected}
                                    onSelect={(selectedKey) => updateAvatar(selectedKey)}
                                    shadow={addShadowLottie[index]}
                                    index={index}
                                    loader={loader && avatar.key === avatarSelected}
                                />
                            ))}
                        </div>
                    </UserArea>
                    <LogoBottomRow>
                        <Logo src={TransparentLogoWhite} />
                    </LogoBottomRow>
                </UserPopUpArea>
            </UserModal>
        </Modal>
    </>)
}